import React from "react";

const Select = ({title, name, disabled, value, options, onChange}) => {
    return (
        <div className="fieldWrapper">
            <label htmlFor={name}>
                {title || name}:
            </label>
            <select
                id={name}
                name={name}
                defaultValue={value}
                onChange={onChange}
            >
                <option value="" disabled>Please select</option>
                {options.map(option => {
                    return (
                        <option key={option} value={option} label={option}>
                            {option}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default Select;
